export default __webpack_public_path__ + "static/media/buick.576d8359.svg";